<div class="p-5">

  <!-- Header -->
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon class="text-aguacate-green mr-2">send</mat-icon>
        Transacciones retiro FIAT enviadas
        <span *ngIf="totalItems"
          class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
          {{ totalItems }} registros
        </span>
      </h1>
      <span *ngIf="totalItems"
        class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
        {{ totalItems }} registros
      </span>
    </div>
  </div>

  <!-- Filtros -->
  <div class="flex justify-center mb-6">
    <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">
      <div class="text-center mb-4">
        <h3 class="text-lg font-semibold text-gray-700 flex items-center justify-center">
          <mat-icon class="text-aguacate-green mr-2">filter_list</mat-icon>
          Filtros de Búsqueda
        </h3>
      </div>
      <div class="flex justify-center">
        <mat-form-field appearance="outline" class="w-full max-w-md modern-field">
          <mat-label>Buscar</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">search</mat-icon>
          <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtrar datos...">
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- ═══ Tabla Desktop ═══ -->
  <div class="hidden lg:block overflow-auto border rounded-lg shadow-md bg-white max-h-[65vh]" *ngIf="dataSource && dataSource.data.length > 0">
    <table mat-table [dataSource]="dataSource" class="w-full table-responsive">

      <!-- ID -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">ID</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs font-bold font-mono">
            {{ row.id }}
          </span>
        </td>
      </ng-container>

      <!-- Estado -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Estado</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getStatusBg(row)"
            style="color: white;">
            {{ row.estado?.replaceAll('_', ' ') }}
          </span>
        </td>
      </ng-container>

      <!-- Fecha Creación -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Fecha creación</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.createdAt | date:'dd/MM/yy HH:mm' }}
        </td>
      </ng-container>

      <!-- Fecha Cierre -->
      <ng-container matColumnDef="fechaTermino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Fecha cierre</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.fechaTermino | date:'dd/MM/yy HH:mm' }}
        </td>
      </ng-container>

      <!-- Nombre Usuario -->
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">Nombre</th>
        <td mat-cell *matCellDef="let row" class="text-left p-2 text-xs font-medium">
          {{ row.nombreUsuario }} {{ row.apellidosUsuario }}
        </td>
      </ng-container>

      <!-- Alias Cuenta Retiro -->
      <ng-container matColumnDef="cuentaRetiroId">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Alias</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.alias }}
        </td>
      </ng-container>

      <!-- Monto Retiro -->
      <ng-container matColumnDef="valorRetiro">
        <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">Monto</th>
        <td mat-cell *matCellDef="let row" class="text-right p-2 text-xs font-bold text-green-600">
          {{ row.totalMonedaOrigen | currency:'$' }}
        </td>
      </ng-container>

      <!-- Banco Destino -->
      <ng-container matColumnDef="bancoDestino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Banco</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.bancoNombre }}
        </td>
      </ng-container>

      <!-- Cuenta Destino -->
      <ng-container matColumnDef="cuentaDestino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Cuenta</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono">
          {{ row.tipoCuentaNombre }} {{ row.numeroCuenta }}
        </td>
      </ng-container>

      <!-- Identificación -->
      <ng-container matColumnDef="identificacion">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Identificación</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono">
          {{ row.tipoIdentificacion }} {{ row.numeroId }}
        </td>
      </ng-container>

      <!-- Operador -->
      <ng-container matColumnDef="operador">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Operador</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.operador || 'N/A' }}
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Acciones</th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <div class="flex gap-1 justify-center items-center flex-wrap">
            <div *ngIf="isManualPending(row)" class="flex flex-col items-center gap-0.5">
              <span [title]="getManualPendingReason(row)"
                class="px-2 py-0.5 rounded-full text-xs font-bold whitespace-nowrap"
                style="background:#fef3c7; color:#92400e;">
                ⏳ Plata sin enviar
              </span>
              <span class="text-[10px] leading-tight" style="color:#92400e; max-width: 150px;">
                {{ getManualPendingShortReason(row) }}
              </span>
            </div>
            <button *ngIf="isManualPending(row)" title="Pagar por Shinkansen" (click)="openPayShinkansenModal(row)"
              style="display: inline-flex; align-items: center; justify-content: center; height: 30px; padding: 0 10px; border: none; border-radius: 6px; background: #1C593D; color: white; cursor: pointer; font-size: 0.75rem; font-weight: 600; gap: 4px;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">payments</mat-icon>
              Pagar
            </button>
            <button *ngIf="isManualPending(row)" title="Registrar que ya se transfirió a mano"
              (click)="markAsPaidManually(row)"
              style="display: inline-flex; align-items: center; justify-content: center; height: 30px; padding: 0 10px; border: 1px solid #1C593D; border-radius: 6px; background: white; color: #1C593D; cursor: pointer; font-size: 0.75rem; font-weight: 600; gap: 4px;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">task_alt</mat-icon>
              Ya se pagó
            </button>
            <button title="Copiar" (click)="copyData(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">content_copy</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- ═══ Mobile / Tablet Cards (Acordeón) ═══ -->
  <div class="lg:hidden">
    <div *ngIf="!dataSource || dataSource.data.length === 0"
      style="text-align: center; padding: 40px 20px;">
      <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">send</mat-icon>
      <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron transacciones</p>
    </div>

    <div *ngFor="let row of dataSource?.data"
      style="border: 1px solid #e5e7eb; border-radius: 10px; overflow: hidden; margin-bottom: 8px;"
      [style.border-color]="expandedCardId === row.id ? '#1C593D' : '#e5e7eb'">

      <!-- Card header -->
      <div (click)="toggleCard(row.id)"
        style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; cursor: pointer; user-select: none;"
        [style.background]="expandedCardId === row.id ? '#f0fdf4' : '#f9fafb'">

        <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap; flex: 1; min-width: 0;">
          <span style="background: #dcfce7; color: #1e5a3f; font-size: 0.7rem; padding: 2px 7px; border-radius: 10px; font-weight: 600;">
            #{{ row.id }}
          </span>
          <span class="px-2 py-0.5 rounded-full" style="font-size: 0.65rem; font-weight: 700; color: white;"
            [style.background]="getStatusBg(row)">
            {{ row.estado?.replaceAll('_', ' ') }}
          </span>
          <span *ngIf="isManualPending(row)" class="px-2 py-0.5 rounded-full"
            style="font-size: 0.65rem; font-weight: 700; background:#fef3c7; color:#92400e;">
            ⏳ Plata sin enviar
          </span>
          <span style="font-size: 0.7rem; color: #374151; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ row.nombreUsuario }} {{ row.apellidosUsuario }}
          </span>
          <span style="font-size: 0.7rem; color: #1e5a3f; font-weight: 700; white-space: nowrap;">
            {{ row.totalMonedaOrigen | currency:'$' }}
          </span>
        </div>

        <mat-icon style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease; flex-shrink: 0; margin-left: 4px;"
          [style.transform]="expandedCardId === row.id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Card body -->
      <div *ngIf="expandedCardId === row.id">
        <div style="padding: 12px 16px; background: white;">
          <div class="grid grid-cols-2 gap-x-12 gap-y-1">

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">ID</span>
              <span style="color: #111827; font-weight: 700; font-size: 0.85rem; font-family: monospace;">
                {{ row.id }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Estado</span>
              <span class="px-2 py-0.5 text-xs font-bold rounded-full"
                [style.background]="getStatusBg(row)"
                style="color: white;">
                {{ row.estado?.replaceAll('_', ' ') }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha creación</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.createdAt | date:'dd/MM/yy HH:mm' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha cierre</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.fechaTermino | date:'dd/MM/yy HH:mm' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Nombre</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.nombreUsuario }} {{ row.apellidosUsuario }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Alias</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.alias }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto</span>
              <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem;">
                {{ row.totalMonedaOrigen | currency:'$' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.bancoNombre }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Operador</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.operador || 'N/A' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Cuenta</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">
                {{ row.tipoCuentaNombre }} {{ row.numeroCuenta }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Identificación</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">
                {{ row.tipoIdentificacion }} {{ row.numeroId }}
              </span>
            </div>

          </div>
        </div>

        <!-- Motivo por el que la plata no salió -->
        <div *ngIf="isManualPending(row)"
          style="padding: 10px 16px; background: #fffbeb; border-top: 1px solid #fde68a;">
          <span style="color: #92400e; font-size: 0.75rem; font-weight: 700; display: block;">
            ⏳ La plata no se envió
          </span>
          <span style="color: #92400e; font-size: 0.75rem;">
            {{ getManualPendingShortReason(row) }}
          </span>
        </div>

        <!-- Action buttons -->
        <div style="display: flex; gap: 6px; flex-wrap: wrap; padding: 10px 16px; background: #f9fafb; border-top: 1px solid #f3f4f6;">
          <button *ngIf="isManualPending(row)" (click)="openPayShinkansenModal(row)"
            style="display: flex; align-items: center; gap: 4px; padding: 8px 12px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">payments</mat-icon>
            Pagar Shinkansen
          </button>
          <button *ngIf="isManualPending(row)" (click)="markAsPaidManually(row)"
            style="display: flex; align-items: center; gap: 4px; padding: 8px 12px; background: white; color: #1C593D; border: 1px solid #1C593D; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">task_alt</mat-icon>
            Ya se pagó
          </button>
          <button (click)="copyData(row)"
            style="display: flex; align-items: center; gap: 4px; padding: 8px 12px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">content_copy</mat-icon>
            Copiar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state desktop -->
  <div *ngIf="!dataSource || dataSource.data.length === 0"
    class="hidden lg:block"
    style="text-align: center; padding: 40px 20px; background: white; border-radius: 12px; border: 1px solid #e5e7eb; margin-top: 8px;">
    <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">search_off</mat-icon>
    <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron transacciones enviadas.</p>
  </div>

  <!-- Paginador -->
  <div *ngIf="dataSource && dataSource.data.length > 0" class="mt-2">
    <mat-paginator #paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [pageIndex]="currentPage - 1"
      aria-label="Select page"
      (page)="onPageChange($event)"
      style="border-radius: 0 0 12px 12px; border: 1px solid #e5e7eb; border-top: none;">
    </mat-paginator>
  </div>

</div>
